import { render, staticRenderFns } from "./CrossRegionMenu.vue?vue&type=template&id=707794cf&scoped=true&"
import script from "./CrossRegionMenu.vue?vue&type=script&lang=ts&"
export * from "./CrossRegionMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707794cf",
  null
  
)

export default component.exports